import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/biocompatibility-biological-evaluation")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/biocompatibility-biological-evaluation", statusCode: 301 }); },
});
